import { collection, getDocs, query, where } from 'firebase/firestore';

import { db } from 'external/firebase/index';

export const getRoleByRoleCode = async (roleCode: string) => {
    let roleId;
    const q = query(collection(db, 'roles'), where('code', '==', roleCode));
    const querySnap = await getDocs(q);
    querySnap.forEach(docSnap => {
        roleId = docSnap.id;
    });
    return roleId;
};
